var map = {
	"./glass-champagne.svg": "b023",
	"./glass-cocktail.svg": "44af",
	"./glass-collins.svg": "39a7",
	"./glass-coupe.svg": "fd24",
	"./glass-cup.svg": "0e2d",
	"./glass-goblet.svg": "32cf",
	"./glass-highball.svg": "b5cf",
	"./glass-hurricane.svg": "fd2a",
	"./glass-martini.svg": "19c4",
	"./glass-mug.svg": "f258",
	"./glass-pilsner.svg": "44d4",
	"./glass-rocks.svg": "7dc2",
	"./glass-snifter.svg": "49cf",
	"./glass-tulip.svg": "d301",
	"./glass-wine.svg": "8b94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e09";